
export const extractCategories = ({ hiveNfts = [] }) => {
  const categories = [];
  hiveNfts.forEach(nft => nft.properties.schema && categories.push(nft.properties.schema));
  const noDupes = Array.from(new Set(categories));
  return noDupes; // .reverse();
};


export const capitalize = (ss = '') => ss[0] && ss[0].toUpperCase() + ss.slice(1);

export const parseSchemaName = (category = '') => {
  const [part1, part2] = category.split('.');
  return `${capitalize(part1)} ${capitalize(part2) || ''}`;
};
